import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  applyJob,
  getOpenJobs,
  getSingleOpenJob,
  saveParticularJob,
} from "../../../../Redux/Reducers/JobReducer";
import { formatDistanceToNow } from "date-fns";
import {
  Card,
  Typography,
  Button,
  Grid,
  Box,
  Avatar,
  IconButton,
  Modal,
} from "@mui/material";
import { BiTime } from "react-icons/bi";
import { LocationOn, WorkOutline } from "@mui/icons-material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import SchoolIcon from "@mui/icons-material/School";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Link, useNavigate } from "react-router-dom";
import { useQuantityContext } from "../../../QuantityContext";
import ShareIcon from "@mui/icons-material/Share";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { ShareProfile } from "../ProfileConnectionComponents";

const FavouriteJobs = () => {
  const dispatch = useDispatch();
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const savedJobsData =
    useSelector((state) => state.jobs?.savedParticularJob) || [];
  const openJobs = useSelector((state) => state.jobs?.allJobs) || [];
  const [selectedJob, setSelectedJob] = useState(null);
  const Resumedata =
    useSelector((state) => state?.ProfileArray?.ResumeData?.data) || [];
  const videoResume = useSelector((state) => state?.ProfileArray?.videoResume);
  const videoUrlArray = videoResume;
  const hasResume = Resumedata?.some((item) => item?.document_url);
  const hasVideoResume = videoUrlArray?.some((item) => item?.document_url);
  const allJobs = openJobs?.open_jobs;
  const navigate = useNavigate();
  const { openSnackbar } = useQuantityContext();

  const savedJobs = allJobs?.filter((job) => job.is_saved === true);

  const handleJobSave = useCallback(
    (jobId) => {
      dispatch(saveParticularJob(jobId))
        .unwrap()
        .then(() => {
          openSnackbar("Job Removed successfully!", "success");
          dispatch(getOpenJobs()); // Refresh jobs list to update UI
        })
        .catch((error) => {
          openSnackbar("Failed to save job", "error");
        });
    },
    [dispatch]
  );

  const handleSingleJobClick = (JobId, source = "open-job") => {
    console.log("IAMJob", JobId);
    dispatch(getSingleOpenJob(JobId));
    navigate(`/job-description/${JobId}`, { state: { source } });
  };

  const handleApplyInitiation = (jobId) => {
    setSelectedJob(jobId);

    if (!hasResume) {
      setShowResumeModal(true);
    } else if (!hasVideoResume) {
      setShowVideoModal(true);
    } else {
      setShowConfirmationModal(true);
    }
  };

  const handleJobApply = useCallback(
    (jobId) => {
      if (window.confirm("Are you sure you want to apply for this job?")) {
        dispatch(applyJob(jobId))
          .unwrap()
          .then((response) => {
            // alert("You have successfully applied for the job!");
            openSnackbar(
              "You have successfully applied for the job!",
              "success"
            );
            dispatch(getOpenJobs());
          })
          .catch((error) => {
            // alert(`Failed to apply for the job. ${error.message}`);
            openSnackbar("Failed to apply for the job", "error");
          });
      }
    },
    [dispatch]
  );

  const handleSuccess = (message, severity = "success", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  const handleFailure = (message, severity = "error", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  const [shareProfileConfig, setShareProfileConfig] = useState({
    open: false,
    onClose: undefined,
    qrCodeUrl: "",
    qrCodeLogo: undefined,
    showQr: true,
    isDownload: false,
    profileType: "",
    handleSuccess: handleSuccess,
    handleFailure: handleFailure,
  });

  const updateShareProfileConfig = (newConfig) => {
    setShareProfileConfig((prev) => ({
      ...prev,
      ...newConfig,
    }));
  };

  const handleJobShare = (job) => {
    // setSelectedJob(job);
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/job-description/${job.id}`,
      showQr: false,
      profileType: "Job",
      handleSuccess,
      handleFailure,
    });
  };

  const formatSalary = (salary) => {
    if (!salary) return "Not Specified"; // If salary is null, undefined, or empty string, return "Not Specified"

    // Check if the salary is already in 'k' format (e.g., '50k', '150k')
    if (/^\d+(\.\d+)?k$/.test(salary)) {
      return salary; // If it's in 'k' format, return the salary as is
    }

    // Check if the salary is a range (e.g., "10000-20000")
    const salaryParts = salary.split("-");

    if (salaryParts?.length === 2) {
      const minSalary = parseInt(salaryParts[0].replace(/,/g, ""));
      const maxSalary = parseInt(salaryParts[1].replace(/,/g, ""));

      // Check if both values are valid numbers
      if (isNaN(minSalary) || isNaN(maxSalary)) {
        return "Not Specified"; // If either value is NaN, return "Not Specified"
      }

      // Convert salary range to 'k' format
      return `${minSalary / 1000}k - ${maxSalary / 1000}k`;
    } else {
      const salaryInK = parseInt(salary.replace(/,/g, ""));

      // If the salary is not a valid number, return "Not Specified"
      if (isNaN(salaryInK)) {
        return "Not Specified";
      }

      return `${salaryInK / 1000}k`; // If it's a single salary, convert to 'k' format
    }
  };

  const parseSkillsArray = (data) => {
    if (!data) return [];

    try {
      // First attempt to parse as JSON
      const parsedData = JSON.parse(data);
      return Array.isArray(parsedData) ? parsedData : [];
    } catch (error) {
      // If JSON parsing fails, check if it's a comma-separated string
      if (typeof data === "string") {
        return data?.split(",").map((skill) => skill.trim());
      }
      // If it's already an array
      if (Array.isArray(data)) {
        return data;
      }
      return [];
    }
  };



const renderPostedDate = (date) => {
  const postedDate = new Date(date);
  const now = new Date();
  const diffInMs = now - postedDate;

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  if (diffInMinutes < 1) {
    return "just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ${diffInMinutes === 1 ? "" :""} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours}h ${diffInHours === 1 ? "" : ""} ago`;
  } else if (diffInDays === 1) {
    return "1d ago";
  } else if (diffInDays < 30) {
    return `${diffInDays}d ago`;
  } else if (diffInMonths < 12) {
    return `${diffInMonths}m ${diffInMonths === 1 ? "" : ""} ago`;
  } else {
    return `${diffInYears}y ${diffInYears === 1 ? "" : ""} ago`;
  }
};

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
     width: {
      xs: "90%",   // mobile
      sm: "70%",   // tablet
      md: "600px", // desktop
    },
    maxWidth: "90vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  return (
    <Box sx={{ p: 3 }}>
      {savedJobs?.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            No saved jobs found
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {savedJobs?.map((job) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={job?.id}
              sx={{ display: "flex", flex: 1 }}
            >
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  width: "80%",

                  // minHeight: viewMode === "grid" ? "min(60vh, 420px)" : "auto",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  justifyContent: "space-between",
                  p: 3,
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: 5,
                  },
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Typography
                    variant="caption"
                    color="gray"
                    sx={{ fontWeight: 500, fontSize: "12px" }}
                  >
                    {renderPostedDate(job?.date_posted)}
                  </Typography>
                  <IconButton
                    size="small"
                    aria-label="share"
                    onClick={() => handleJobShare(job)}
                    sx={{ fontSize: "16px" }}
                  >
                    {job?.status == "open" ? (
                      <ShareIcon fontSize="small" />
                    ) : (
                      ""
                    )}
                  </IconButton>
                  <IconButton
                    size="small"
                    aria-label="save"
                    sx={{ fontSize: "16px" }}
                    onClick={() => handleJobSave(job?.id)}
                  >
                    {job?.is_saved ? (
                      <BookmarkIcon fontSize="small" />
                    ) : (
                      <BookmarkBorderIcon fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                <Box>
                  {/* <Link to={`/job-description/${job?.id}`}> */}
                  <Box
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleSingleJobClick(job?.id)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mb: 0.5,
                      }}
                    >
                      {/* {logourl[job.id] ? ( */}
                      <img
                        width="75px"
                        height="75px"
                        src={
                          job?.company_logo
                            ? job?.company_logo
                            : "https://www.shutterstock.com/image-vector/image-icon-trendy-flat-style-600nw-643080895.jpg"
                        }
                        alt="Logo API"
                      />
                    </Box>

                    <Box>
                      {/* Job Role */}
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          fontSize: "16px",
                          color: "black",
                        }}
                      >
                        {job?.role}
                      </Typography>
                      {/* Company Name */}
                      <Typography
                        variant="body2"
                        sx={{
                          textAlign: "start",
                          fontSize: "16px",
                          color: "#00000099",
                          p: "3px",
                        }}
                      >
                        {job?.company_name}
                      </Typography>
                    </Box>

                    <Grid
                      container
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: 0.5,
                        my: "3px",
                        // p: 1,
                        overflowX: "visible",
                        "&::-webkit-scrollbar": { display: "none" },
                        scrollbarWidth: "none",
                      }}
                    >
                      {/* Education Level */}
                      <Grid item>
                        <Typography
                          variant="body2"
                          display="flex"
                          alignItems="center"
                          sx={{
                            color: "#000000DE",
                            fontSize: "12px",
                            // bgcolor: '#f5f5f5',
                            p: "5px 5px",
                            borderRadius: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            minWidth: "auto",
                            height: "32px",
                          }}
                        >
                          <SchoolIcon
                            fontSize="small"
                            sx={{
                              mr: 1,
                              color: "#0000008A",
                              width: "16px",
                              height: "16px",
                            }}
                          />
                          {job?.edu_level || "Not Specified"}
                        </Typography>
                      </Grid>

                      {/* Experience */}
                      <Grid item>
                        <Typography
                          variant="body2"
                          display="flex"
                          alignItems="center"
                          sx={{
                            color: "#000000DE",
                            fontSize: "12px",
                            // bgcolor: '#f5f5f5',
                            p: "5px 5px",
                            borderRadius: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            minWidth: "auto",
                            height: "32px",
                          }}
                        >
                          <WorkOutline
                            fontSize="small"
                            sx={{
                              mr: 1,
                              color: "#0000008A",
                              width: "16px",
                              height: "16px",
                            }}
                          />
                          {job?.experience || "Not Specified"}
                        </Typography>
                      </Grid>

                      {/* Salary */}
                      <Grid item>
                        <Typography
                          variant="body2"
                          display="flex"
                          alignItems="center"
                          sx={{
                            color: "#000000DE",
                            fontSize: "12px",
                            // bgcolor: '#f5f5f5',
                            p: "5px 5px",
                            borderRadius: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            minWidth: "auto",
                            height: "32px",
                          }}
                        >
                          <CurrencyRupeeIcon
                            fontSize="small"
                            sx={{
                              mr: 1,
                              color: "#0000008A",
                              width: "16px",
                              height: "16px",
                            }}
                          />
                          {formatSalary(job?.salary) || "Not Specified"}
                        </Typography>
                      </Grid>

                      {/* Location */}
                      <Grid item>
                        <Typography
                          variant="body2"
                          display="flex"
                          alignItems="center"
                          sx={{
                            color: "#000000DE",
                            fontSize: "12px",
                            // bgcolor: '#f5f5f5',
                            p: "5px 5px",
                            borderRadius: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            minWidth: "auto",
                            height: "32px",
                          }}
                        >
                          <LocationOn
                            fontSize="small"
                            sx={{
                              mr: 1,
                              color: "#0000008A",
                              width: "16px",
                              height: "16px",
                            }}
                          />
                          {job?.location?.split(",")[0].trim() ||
                            "Not Specified"}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Typography
                      variant="body2"
                      sx={{
                        mb: 1.2,
                        fontSize: "14px",
                        color: "#000000DE",
                        mt: 1,
                      }}
                    >
                      <CalendarMonthIcon
                        fontSize="small"
                        sx={{
                          mr: 0.5,
                          color: "#0000008A",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      {(() => {
                        try {
                          // No need to parse, job?.responsibility is already an array
                          const responsibilities = job?.responsibility;

                          if (
                            Array.isArray(responsibilities) &&
                            responsibilities?.length > 0
                          ) {
                            const text = responsibilities.join(" "); // Convert array to string
                            return (
                              text.split(" ").slice(0, 10).join(" ") + "..."
                            ); // Limit to 10 words
                          }
                        } catch (error) {
                          let text =
                            job?.responsibility ||
                            "Responsibility details not available.";

                          // Ensure text is a string before using split
                          if (Array.isArray(text)) {
                            text = text.join(" "); // Convert array to string
                          }

                          return text.split(" ").slice(0, 10).join(" ") + "..."; // Limit to 10 words
                        }
                      })()}
                      <span
                        style={{
                          color: "#007BFF",
                          cursor: "pointer",
                          marginLeft: 5,
                        }}
                      >
                        ...More
                      </span>
                    </Typography>

                    <Box
                      sx={{
                        p: 0.2,
                        height: "10vh",
                        overflowY: "scroll",
                        scrollbarWidth: "none",
                      }}
                    >
                      {job?.skills ? (
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                            "& > *": {
                              maxWidth: "none",
                            },
                            maskImage:
                              "linear-gradient(to bottom, black 80%, transparent 100%)",
                          }}
                        >
                          {parseSkillsArray(job?.skills).map(
                            (skill, index, arr) => {
                              const maxSkills = 4;
                              if (index >= maxSkills) {
                                if (index === maxSkills) {
                                  return (
                                    <Typography
                                      key="more"
                                      variant="body2"
                                      sx={{
                                        color: "#007BFF",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      +{arr.length - maxSkills} more
                                    </Typography>
                                  );
                                }
                                return null;
                              }
                              return (
                                <Typography
                                  key={index}
                                  variant="body2"
                                  sx={{
                                    color: "gray",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    fontSize: "12px",
                                    lineHeight: "20px",
                                    backgroundColor: "#f5f5f5",
                                    padding: "2px 8px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {skill.trim()}
                                </Typography>
                              );
                            }
                          )}
                        </Box>
                      ) : (
                        <Typography variant="body2" sx={{ color: "gray" }}>
                          Skills not specified.
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  {/* </Link> */}
                </Box>
                <Box
                  sx={{
                    width: "30%",
                  }}
                >
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    sx={{
                      width: "100%",
                      // Add disabled styling
                      "&:disabled": {
                        backgroundColor: "#f5f5f5",
                        color: "text.disabled",
                      },
                    }}
                    onClick={() => handleApplyInitiation(job?.id)}
                    disabled={job?.status === "close"}
                  >
                    {job?.status === "close" ? "Closed" : "Apply"}
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      <ShareProfile
        open={shareProfileConfig?.open}
        onClose={shareProfileConfig?.onClose}
        qrCodeUrl={shareProfileConfig?.qrCodeUrl}
        showQr={shareProfileConfig?.showQr}
        profileType={shareProfileConfig?.profileType}
        handleSuccess={shareProfileConfig?.handleSuccess}
        handleFailure={shareProfileConfig?.handleFailure}
      />

      <Modal
        open={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
      >
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Confirm Application
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Are you sure you want to apply for this position?
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "right" }}>
            <Button
              variant="outlined"
              onClick={() => setShowConfirmationModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setShowConfirmationModal(false);
                // Actual apply action
                dispatch(applyJob(selectedJob))
                  .unwrap()
                  .then(() => {
                    openSnackbar("Successfully applied!", "success");
                    dispatch(getOpenJobs());
                  })
                  .catch(() => {
                    openSnackbar("Application failed", "error");
                  });
              }}
            >
              Confirm Apply
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={showVideoModal} onClose={() => setShowVideoModal(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Video Resume Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            A video resume is mandatory to apply for this position. Create your
            video resume to proceed with the application.
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={() =>
                navigate(
                  "/myprofile?mainTab=professional_profile&subTab=video_resume"
                )
              }
            >
              Create Video Resume
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={showResumeModal} onClose={() => setShowResumeModal(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Resume Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Please generate your AI Resume to apply for this position.
          </Typography>
          <Button
            variant="contained"
            onClick={() =>
              navigate("/myprofile?mainTab=professional_profile&subTab=resume")
            }
          >
            Generate AI Resume
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default FavouriteJobs;
